import config from "config";
import WSService from "./ws.service";
import LocalStorageService from "./LocalStorage.service";

let socket: WSService | null = null;

export function initSocket() {
  if (!socket) {
    socket = new WSService(
      config.webSocketUrl,
      LocalStorageService.getAccessToken()
    );
  }
  return socket;
}

export function getSocket() {
  return socket;
}

export function destroySocket() {
  if (socket) {
    socket.destroy();
    socket = null;
  }
}
